<template>
  <div>
    <!-- https://v2.vuetifyjs.com/en/components/sliders/ -->
    <v-slider
      ticks="always"
      tick-size="4"
      :tick-labels="[0, 200, 400, 600, 800, 1000, 1200, 1400, 1600, 1800, 2000]"
      hint="delay"
      step="200"
      min="0"
      max="2000"
      hide-details
      :value="value()"
      @change="onChangeDelay"
    ></v-slider>
  </div>
</template>

<script>
export default {
  model: {
    prop: "cmd",
    event: "change",
  },
  props: {
    cmd: {
      type: Object,
      default: () => ({ delay: null }),
    },
  },
  data() {
    return {
      // delay: 0,
    };
  },
  methods: {
    value() {
      if (!this.cmd) return 0;
      return this.cmd.delay;
    },
    onChangeDelay(value) {
      this.$emit("change", value);
    },
  },
};
</script>

<style></style>
